import { defineStore } from 'pinia'

type State = {
  user: AuthenticatedUser,
  authenticated: -1 | 0 | 1, // 0 = false, 1 = true, -1 = unknown
  branch: AuthenticatedBranch | null,
}

export const useAuthStore = defineStore('Auth', {
  state: (): State => ({
    user: {
      id: 0,
      name: '',
      username: '',
      role: '',
      branch_id: null,
    },
    branch: {
      id: 0,
      name: '',
      code: '',
      color: '',
      facility_type: '',
      receipt_header: '',
      last_stockopname_at: null,
      company: {
        id: 0,
        name: '',
        has_vat: false,
      },
      discount_require_password: true,
    },
    authenticated: -1,
  }),
  actions: {
    setUser (user: AuthenticatedUser) {
      this.user = user
    },
    setAuthenticated (authenticated: -1 | 0 | 1) {
      this.authenticated = authenticated
    },
    setBranch (branch: AuthenticatedBranch) {
      this.branch = branch
    },
  },
})
